export class JobProgressStepBucketDataBackupDataCoverageNotBackedUpInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "reason",
            "baseName": "reason",
            "type": "JobProgressStepBucketDataBackupDataCoverageNotBackedUpInnerReasonEnum",
            "format": ""
        },
        {
            "name": "objects",
            "baseName": "objects",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "bytes",
            "baseName": "bytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepBucketDataBackupDataCoverageNotBackedUpInner.attributeTypeMap;
    }
    constructor() {
    }
}
export var JobProgressStepBucketDataBackupDataCoverageNotBackedUpInnerReasonEnum;
(function (JobProgressStepBucketDataBackupDataCoverageNotBackedUpInnerReasonEnum) {
    JobProgressStepBucketDataBackupDataCoverageNotBackedUpInnerReasonEnum["AccessDenied"] = "ACCESS_DENIED";
    JobProgressStepBucketDataBackupDataCoverageNotBackedUpInnerReasonEnum["UserFiltered"] = "USER_FILTERED";
    JobProgressStepBucketDataBackupDataCoverageNotBackedUpInnerReasonEnum["ChangedDuringBackup"] = "CHANGED_DURING_BACKUP";
})(JobProgressStepBucketDataBackupDataCoverageNotBackedUpInnerReasonEnum || (JobProgressStepBucketDataBackupDataCoverageNotBackedUpInnerReasonEnum = {}));
